import { StatisticsUserModel } from './statistics-user.model';

export class AllocationModel {
  constructor(
    public id: string,
    public name: string,
    public show: boolean,
    public users: Array<StatisticsUserModel>
  ) {}
}
